export default {
    home: {
        updatePwd: "Update Password",
        myMessage: "Informasi Saya",
        set: "Setting",
        switch:"Switch",
        logout: "Logout",
        loginName: "Nama Login",
        password: "Password",
        confirmPassword: "Konfirmasi Password",
        sure: "Yakin",
        filter: "Saring",
        confirmLogout:"Konfirmasi keluar?",
        tip:"prompt",
        basic:"basis",
          userInfo:"个人信息",
          companyName:"公司",
          employeeName:"姓名",
          officeName:"部门",
          positionName:"岗位",
          leaderName:"上级",
          regularDate:"转正日期",
          notify:"通知中心",
          dutySize:"待批考勤",
          auditFileSize:"待批文件",
          overtimeHour:"可用调休",
          annualHour:"可用调休年假",
          expiredHour:"即将过期",
          messageCount:"未读通知",
          assetAuditCount:"行政待审核",
          shopAd:"广告申请",
          regulashopAdDoorrDate:"制作广告",
          inputPassword:"Silakan Input Password",
          passwordReg:"密码长度6-16位,数字、字母、字符至少包含两种",
          inputConfirmPassword:"请输入确认密码",
          notSame:"两次输入密码不一致!"
    },
}


// WEBPACK FOOTER //
// ./src/i18n/home_id.js